export default (props = {}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M15.7027 6.69892L14.642 7.75958L18.1342 11.2523H2.9939V12.7523H18.1342L14.642 16.2449L15.7027 17.3056L21.006 12.0023L15.7027 6.69892Z" fill="#888888"/>
</svg>
